export const ADD_DETAILS_MODAL_ID = 'add-bank-details';
